export default "__VITE_ASSET__lkGeNmYO__"